module.exports = __webpack_public_path__ + "thumbnail.57732a42.webp";